import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FULL_ROUTES } from '@shared/constants';
import { UserType } from '@shared/enums/user-type.enum';
import { AuthService } from '../../shared/services/auth.service';

@Component({
  selector: 'app-landing-redirect',
  template: '',
})
export class LandingRedirect implements OnInit {
  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit(): void {
    this.redirectBasedOnUserType();
  }

  private redirectBasedOnUserType(): void {
    try {
      // Check if token is expired
      if (this.authService.isTokenExpired()) {
        this.router.navigate([FULL_ROUTES.LOGIN]);
        return;
      }

      // Redirect based on user type
      const userType = this.authService.getUserType();
      if (userType === UserType.EMPLOYEE) {
        this.router.navigate([FULL_ROUTES.ADMIN]);
      } else if (userType === UserType.LEARNER) {
        this.router.navigate([FULL_ROUTES.LEARNER]);
      } else {
        this.router.navigate([FULL_ROUTES.LOGIN]);
      }
    } catch (error) {
      console.error('Error during redirection:', error);
      this.router.navigate([FULL_ROUTES.LOGIN]);
    }
  }
}
